<template>
  <div class="progress-bar">
    <div class="label" v-if="name">{{ name }}</div>
    <el-progress :percentage="percentageValue" :color="colors" :status="statusValue"></el-progress>
  </div>
</template>

<script>
import { Progress } from "element-ui";

export default {
  name: "ProgressBar",
  components: {
    ElProgress: Progress
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    percentage: {
      type: [String, Number],
      default: 0
    },
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      percentageValue: this.percentage || 0,
      statusValue: this.status || undefined,
      colors: [
        { color: "#1989fa", percentage: 30 },
        { color: "#6f7ad3", percentage: 60 },
        { color: "#5cb87a", percentage: 100 }
      ]
    };
  },

  mounted() {},

  methods: {
    setPercentage(val) {
      this.percentageValue = val;
    },
    setStatus(val) {
      this.setStatusVal = val;
    }
  }
};
</script>

<style lang="less" scoped>
.progress-bar {
  width: 100%;
  height: auto;
}
</style>
